// extracted by mini-css-extract-plugin
export default {"HeaderContainer":"Header_HeaderContainer__isznQ","Stack":"Header_Stack__kqvmH"};